export const STT_LANGUAGES = [
  { name: 'Afrikaans', code: 'af_ZA' },
  { name: 'Albanian', code: 'sq_AL' },
  { name: 'Amharic', code: 'am_ET' },
  { name: 'Arabic', code: 'ar_EG' },
  { name: 'Armenian', code: 'hy_AM' },
  { name: 'Azerbaijani', code: 'az_AZ' },
  { name: 'Basque', code: 'eu_ES' },
  { name: 'Belarusian', code: 'be_BY' },
  { name: 'Bengali', code: 'bn_BD' },
  { name: 'Bosnian', code: 'bs_BA' },
  { name: 'Bulgarian', code: 'bg_BG' },
  { name: 'Catalan', code: 'ca_ES' },
  { name: 'Chinese (Simplified)', code: 'zh-Hans_CN' },
  { name: 'Chinese (Traditional)', code: 'zh-Hant_TW' },
  { name: 'Croatian', code: 'hr_HR' },
  { name: 'Czech', code: 'cs_CZ' },
  { name: 'Danish', code: 'da_DK' },
  { name: 'Dutch', code: 'nl_NL' },
  { name: 'English', code: 'en_GB' },
  { name: 'Esperanto', code: 'eo_WORLD' },
  { name: 'Estonian', code: 'et_EE' },
  { name: 'Finnish', code: 'fi_FI' },
  { name: 'French', code: 'fr_FR' },
  { name: 'Galician', code: 'gl_ES' },
  { name: 'Georgian', code: 'ka_GE' },
  { name: 'German', code: 'de_DE' },
  { name: 'Greek', code: 'el_GR' },
  { name: 'Gujarati', code: 'gu_IN' },
  { name: 'Haitian Creole', code: 'ht_HT' },
  { name: 'Hausa', code: 'ha_NE' },
  { name: 'Hawaiian', code: 'haw_US' },
  { name: 'Hebrew', code: 'he_IL' },
  { name: 'Hindi', code: 'hi_IN' },
  { name: 'Hungarian', code: 'hu_HU' },
  { name: 'Icelandic', code: 'is_IS' },
  { name: 'Indonesian', code: 'id_ID' },
  { name: 'Italian', code: 'it_IT' },
  { name: 'Japanese', code: 'ja_JP' },
  { name: 'Javanese', code: 'jv_ID' },
  { name: 'Kannada', code: 'kn_IN' },
  { name: 'Kazakh', code: 'kk_KZ' },
  { name: 'Khmer', code: 'km_KH' },
  { name: 'Korean', code: 'ko_KR' },
  { name: 'Kyrgyz', code: 'ky_KG' },
  { name: 'Lao', code: 'lo_LA' },
  { name: 'Latin', code: 'la_VAT' },
  { name: 'Latvian', code: 'lv_LV' },
  { name: 'Lithuanian', code: 'lt_LT' },
  { name: 'Luxembourgish', code: 'lb_LU' },
  { name: 'Macedonian', code: 'mk_MK' },
  { name: 'Malagasy', code: 'mg_MG' },
  { name: 'Malay', code: 'ms_MY' },
  { name: 'Malayalam', code: 'ml_IN' },
  { name: 'Maltese', code: 'mt_MT' },
  { name: 'Maori', code: 'mi_NZ' },
  { name: 'Marathi', code: 'mr_IN' },
  { name: 'Mongolian', code: 'mn_MN' },
  { name: 'Myanmar (Burmese)', code: 'my_MM' },
  { name: 'Nepali', code: 'ne_NP' },
  { name: 'Norwegian', code: 'no_NO' },
  { name: 'Pashto', code: 'ps_AF' },
  { name: 'Persian', code: 'fa_IR' },
  { name: 'Polish', code: 'pl_PL' },
  { name: 'Portuguese', code: 'pt_PT' },
  { name: 'Punjabi', code: 'pa_PK' },
  { name: 'Romanian', code: 'ro_RO' },
  { name: 'Russian', code: 'ru_RU' },
  { name: 'Serbian Cyrilic', code: 'sr-Cyrl_RS' },
  { name: 'Shona', code: 'sn_ZW' },
  { name: 'Sindhi', code: 'sd_PK' },
  { name: 'Sinhala', code: 'si_LK' },
  { name: 'Slovak', code: 'sk_SK' },
  { name: 'Slovenian', code: 'sl_SI' },
  { name: 'Somali', code: 'so_SO' },
  { name: 'Spanish', code: 'es_ES' },
  { name: 'Sundanese', code: 'su_ID' },
  { name: 'Swahili', code: 'sw_TZ' },
  { name: 'Swedish', code: 'sv_SE' },
  { name: 'Tagalog', code: 'tl_PH' },
  { name: 'Tajik', code: 'tg_TJ' },
  { name: 'Tamil', code: 'ta_IN' },
  { name: 'Tatar', code: 'tt_TT' },
  { name: 'Telugu', code: 'te_IN' },
  { name: 'Thai', code: 'th_TH' },
  { name: 'Turkish', code: 'tr_TR' },
  { name: 'Turkmen', code: 'tk_TM' },
  { name: 'Ukrainian', code: 'uk_UA' },
  { name: 'Urdu', code: 'ur_PK' },
  { name: 'Uzbek', code: 'uz_UZ' },
  { name: 'Vietnamese', code: 'vi_VN' },
  { name: 'Welsh', code: 'cy_GB' },
  { name: 'Yiddish', code: 'yi_IL' },
  { name: 'Yoruba', code: 'yo_NG' },
] as const

/** Languages the gateway can translate a finished transcript into, but cannot
 * transcribe. Speech recognition covers the 93 above; translation covers 110,
 * and this is the difference. Codes are the gateway's own (`/getLanguages`).
 * Kept in their own array so the SEO pages, which advertise transcription,
 * stay bound to STT_LANGUAGES. */
const TRANSLATE_ONLY_LANGUAGES = [
  { name: 'Cebuano', code: 'ceb_PH' },
  { name: 'Chichewa', code: 'ny_MW' },
  { name: 'Corsican', code: 'co_FR' },
  { name: 'Frisian', code: 'fy_NL' },
  { name: 'Hmong', code: 'hmn_CN' },
  { name: 'Igbo', code: 'ig_NG' },
  { name: 'Irish', code: 'ga_IE' },
  { name: 'Kinyarwanda', code: 'rw_RW' },
  { name: 'Kurdish', code: 'ku_IR' },
  { name: 'Odia', code: 'or_OR' },
  { name: 'Portuguese (Brazil)', code: 'pt_BR' },
  { name: 'Samoan', code: 'sm_WS' },
  { name: 'Scottish Gaelic', code: 'gd_GB' },
  { name: 'Sesotho', code: 'st_LS' },
  { name: 'Uyghur', code: 'ug_CN' },
  { name: 'Xhosa', code: 'xh_ZA' },
  { name: 'Zulu', code: 'zu_ZA' },
] as const

/** Every target the "Translate to" picker offers, by name. */
export const TRANSLATE_LANGUAGES: { name: string; code: string }[] = [
  ...STT_LANGUAGES,
  ...TRANSLATE_ONLY_LANGUAGES,
].sort((a, b) => a.name.localeCompare(b.name))

export const RTL_LANGUAGE_CODES = new Set([
  'ar_EG', 'fa_IR', 'he_IL', 'ps_AF', 'sd_PK', 'ur_PK', 'yi_IL',
  // Translation-only. Uyghur is Arabic-script; Kurdish is NOT — the gateway
  // answers ku_IR in Kurmanji Latin ("Silav, tu îro çawa yî?"), so flagging
  // it here flipped a left-to-right text on its head.
  'ug_CN',
])

// Analytics helpers — short ISO-style codes and English names, matching the
// convention used across Lingvanex products ("Language First Code": "en")
const SHORT_CODE_OVERRIDES: Record<string, string> = {
  'zh-Hans_CN': 'zh-hans',
  'zh-Hant_TW': 'zh-hant',
  'sr-Cyrl_RS': 'sr',
}

export function sttShortCode(code: string): string {
  return SHORT_CODE_OVERRIDES[code] ?? code.split('_')[0].toLowerCase()
}

export function sttEnglishName(code: string): string {
  return TRANSLATE_LANGUAGES.find((l) => l.code === code)?.name ?? code
}
